import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { AuthenticationInjection } from "features/login/di/AuthenticationInjection";
import { injectable } from "tsyringe";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { AuthenticationRequestEntity } from "../entities/AuthenticationRequestEntity";
import { AuthenticationResponseEntity } from "../entities/AuthenticationResponseEntity";
import { IAuthenticationRepository } from "../repositories/IAuthenticationRepository";

@injectable()
export class AuthenticationUseCase {
  private authenRepo: IAuthenticationRepository;

  constructor() {
    this.authenRepo = AuthenticationInjection.getAuthenticationRepo();
  }

  async login(
    body: AuthenticationRequestEntity
  ): Promise<BaseApiResponseModel<AuthenticationResponseEntity>> {
    localStorage.setItem(
      CacheKeyEnum.isSavedForNextLogin,
      `${body?.isSavedForNextLogin}`
    );
    delete body?.isSavedForNextLogin;
    const updatedBody = new AuthenticationRequestEntity().switchMode(
      body,
      "login"
    );
    return await this.authenRepo.login(updatedBody);
  }

  async signUp(
    body: AuthenticationRequestEntity
  ): Promise<BaseApiResponseModel<AuthenticationResponseEntity>> {
    const updatedBody = new AuthenticationRequestEntity().switchMode(
      body,
      "signUp"
    );
    return await this.authenRepo.signUp(updatedBody);
  }
}
